let gallerySlideshowSwiper = new Swiper('.gallery-display-as-slideshow .swiper', {
	slidesPerView: 'auto',
	spaceBetween:  16,
	speed:         500,
	autoHeight:    true,
	pagination:    {
		el:        ".swiper-pagination",
		clickable: true
	},
	/*loop:          true,
	autoplay:      {
		delay:                3000,
		stopOnLastSlide:      false
	},*/
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
		addIcons: false
	}
});

let gallerySwiper = new Swiper('.module-slideshow .swiper', {
	slidesPerView:      'auto',
	spaceBetween:       16,
	slidesOffsetBefore: 16,
	slidesOffsetAfter:  16,
	navigation:         {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
		addIcons: false
	},
	breakpoints:        {
		992: {
			slidesOffsetBefore: () => {
				return window.visualViewport.width / 12 * 2 + 8;
			},
		}
	}
});

let moduleTestimonialsSwiper = new Swiper('.module-testimonials .swiper', {
	slidesPerView:      'auto',
	spaceBetween:       0,
	navigation:         {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
		addIcons: false
	}
});